<template>
  <img class="avatar" width="50" height="50" :src="src" />
</template>

<script>
export default {
  props: { src: { type: String, default: '' } }
}
</script>
